import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import drawer from "../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg";
import downarrow from "../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../css/ProfileManagement/AddProfile.css";
import Header from "../../Shared/Header";
import Footer from "../../Shared/Footer";
import Footer2 from "../../Shared/Footer2";
import Button from "../../Shared/Button";
import DropDownTable from "../../Shared/DropDownTable";
import AddProfileModal from "../../Shared/GenericModalError";
import SubmitModal from "../../Shared/SubmitModal";
import Message from "../../../Data/Shared/Message.json";
import MetaDecorator from "../../../ReactHelmet/MetaDecorator";
import TitleDescription from "../../../Data/Shared/TitleDescription.json";
import { useSelector } from "react-redux";
import { baseURL, workFlowBaseURL } from "../../../Services/config/apiGateway";
import {
  START_PROFILE_ENDPOINT,
  GET_ALL_ROLES_ENDPOINT,
} from "../../../Services/config/apiEndPoints";
import { ApiCall } from "../../../Services/utils/ApiCall";
import { AES, enc } from "crypto-js";
let companyInfoDetailsOfRespondent;

const AddProfile = (props) => {
  let history = useHistory();
  const paramObj = useParams();
  const userProfileDataR = useSelector((state) =>
    JSON.parse(
      AES.decrypt(
        state.userProfileInfoReducer.data,
        "TPT_CARGO_CONNECT"
      ).toString(enc.Utf8)
    )
  );
  const [viewProfileType, setViewProfileType] = useState("");
  const container = React.createRef();
  const [roleTypeData, setRoleTypeData] = useState("");
  const [selectedRoleType, setSelectedRoleType] = useState("");
  const [pathRoleType, setPathRoleType] = useState("");
  const [roleNameData, setRoleNameData] = useState("");
  const [roleIdData, setRoleIdData] = useState("");
  const [dropDownRoleType, setDropDownRoleType] = useState(false);
  const [dropDownRoleName, setDropDownRoleName] = useState(false);
  const [errors, setErrors] = useState({});
  const [modalErrorMassage, setmodalErrorMassage] = useState("");
  const [openProfileErrorModal, setopenProfileErrorModal] = useState(false);
  const [dropdownImagePointer, setdropdownImagePointer] = useState(true);
  const [
    isRespondentProfileAppooved,
    setisRespondentProfileAppooved,
  ] = useState(false);
  const [hasOpenOnSubmit, sethasOpenOnSubmit] = useState(false);
  const [profileStatus, setprofileStatus] = useState();
  const [usePathValues, setUsePathValues] = useState(true);
  const [CreatedRoleData, setCreatedRoleData] = useState([]);
  const [roleMessage, setRoleMessage] = useState("");
  const [RoleData, setRoleData] = useState([]);
  const getAppRoles = () => {
    ApiCall(
      "GET",
      baseURL + GET_ALL_ROLES_ENDPOINT,
      {},
      {
        Accept: "application/json",
        "Content-Type": "application/json",
      }
    ).then((data) => {
      if (data.flag != -1) {
        if (data.flag == 500) {
          console.log("I am 500!");
        } else {
          console.log("I am 200!");
          setRoleData(data);
        }
      } else {
        console.log("Something went wrong!");
      }
    });
  };
  useEffect(() => {
    getAppRoles();
    let rolesData1 = userProfileDataR?.profileRoles?.filter(
      (role) => !["Preview", "preview"].includes(role.roleType)
    );
    //set roles data for check profile is already present or not
    setCreatedRoleData(rolesData1);
    const {
      roleId,
      roleTypeValue,
      roleNameValue,
      profileTypeAndStatusValue,
    } = paramObj;
    if (usePathValues) {
      setViewProfileType(roleTypeValue);
      setRoleTypeData(roleTypeValue);
      setPathRoleType(roleTypeValue);
      setRoleNameData(roleNameValue);
      setRoleIdData(roleId);
      setprofileStatus(profileTypeAndStatusValue);
      setUsePathValues(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    if (
      (roleTypeValue == "Requester" ||
        roleTypeValue == "Respondent" ||
        roleTypeValue == "Driver") &&
      ["Pending", "pending", "PENDING"].includes(profileTypeAndStatusValue)
    ) {
      setDropDownRoleType(false);
      setdropdownImagePointer(false);
    } else if (
      (roleTypeValue == "Requester" ||
        roleTypeValue == "Respondent" ||
        roleTypeValue == "Driver") &&
      [
        "Not Completed",
        "Not completed",
        "not completed",
        "NOT COMPLETED",
      ].includes(profileTypeAndStatusValue)
    ) {
      if (roleTypeValue === "Requester") {
        setSelectedRoleType("Requester");
      } else if (roleTypeValue === "Respondent") {
        setSelectedRoleType("Respondent");
      } else if (roleTypeValue == "Driver") {
        setSelectedRoleType("Driver");
      }
    } else if (
      (roleTypeValue == "Requester" ||
        roleTypeValue == "Respondent" ||
        roleTypeValue == "Driver") &&
      [
        "Approved",
        "approved",
        "APPROVED",
        "rejected",
        "Rejected",
        "REJECTED",
      ].includes(profileTypeAndStatusValue)
    ) {
      setDropDownRoleType(false);
      setdropdownImagePointer(false);
      if (roleTypeValue === "Requester") {
        setSelectedRoleType("Requester");
      } else if (roleTypeValue === "Respondent") {
        setSelectedRoleType("Respondent");
      } else if (roleTypeValue == "Driver") {
        setSelectedRoleType("Driver");
      }
    }
  }, []);
  const changeRoleType = (event) => {
    const found = RoleData?.find((name) => {
      if (name.role === RoleData[event].role) {
        return name;
      }
    });
    setRoleTypeData(found.role);
    setDropDownRoleType(false);
    setRoleNameData("");
    if (
      RoleData[event].role === "Requester" ||
      viewProfileType === "Requester"
    ) {
      CreatedRoleData?.map((name, index) => {
        if (
          name.roleType === "Respondent" &&
          ["Approved", "approved", "APPROVED"].includes(name.profileStatus)
        ) {
          return setisRespondentProfileAppooved(true);
        }
      });
      setSelectedRoleType("Requester");
      setRoleMessage("is a user who makes a request for a logistics service.");
    } else if (
      RoleData[event].role === "Respondent" ||
      viewProfileType === "Respondent"
    ) {
      CreatedRoleData?.map((name, index) => {
        if (
          name.roleType === "Requester" &&
          ["Approved", "approved", "APPROVED"].includes(name.profileStatus)
        ) {
          return setisRespondentProfileAppooved(true);
        }
      });
      setSelectedRoleType("Respondent");
      setRoleMessage("is a user who provides a logistics service.");
    } else {
      setSelectedRoleType("Driver");
      setRoleMessage(
        "is someone who executes transportation of goods from source to destination."
      );
      setisRespondentProfileAppooved(false);
    }
  };
  const onCloseSubmitModal = () => {
    sethasOpenOnSubmit(false);
    history.push("/home");
  };
  const onCloseProfileErrorModal = () => {
    setopenProfileErrorModal(false);
  };
  const changeRoleName = (event) => {
    RoleData?.find((name) => {
      name.roleType?.find((data) => {
        if (data.roleName === event.target.innerText) {
          setRoleIdData(data.roleId);
          return name;
        }
      });
    });
    setRoleNameData(event.target.innerText);
    setDropDownRoleName(false);
  };
  const validate = () => {
    let error = {};
    let isValid = true;
    if (!roleTypeData) {
      isValid = false;
      error["roletype"] = Message.validation.required;
    }
    if (!roleNameData) {
      isValid = false;
      error["rolename"] = Message.validation.required;
    }
    if (isValid) {
      if (
        !profileStatus ||
        ([
          "Not Completed",
          "Not completed",
          "not completed",
          "NOT COMPLETED",
        ].includes(profileStatus) &&
          pathRoleType !== selectedRoleType)
      ) {
        CreatedRoleData?.map((name) => {
          if (name.roleType === roleTypeData) {
            return (
              (isValid = false),
              setRoleMessage(""),
              setRoleTypeData(""),
              setRoleNameData(""),
              setmodalErrorMassage(Message.profileManagement.existingProfile),
              setopenProfileErrorModal(true)
            );
          }
        });
      }
    }
    setErrors(error);
    if (!profileStatus) {
      // add profile flow
      if (roleTypeData === "Requester" || viewProfileType === "Requester") {
        let RequesterProfileStatus = "";
        CreatedRoleData?.map((name, index) => {
          if (
            name.roleType === "Respondent" &&
            [
              "Pending",
              "pending",
              "PENDING",
              "Not Completed",
              "Not completed",
              "not completed",
              "NOT COMPLETED",
              "Rejected",
              "rejected",
              "REJECTED",
            ].includes(name.profileStatus)
          ) {
            return (RequesterProfileStatus = name.profileStatus);
          }
        });
        if (
          [
            "Pending",
            "pending",
            "PENDING",
            "Not Completed",
            "Not completed",
            "not completed",
            "NOT COMPLETED",
            "Rejected",
            "rejected",
            "REJECTED",
          ].includes(RequesterProfileStatus)
        ) {
          isValid = false;
          setRoleMessage("");
          setSelectedRoleType("");
          setRoleTypeData("");
          setRoleNameData("");
          setmodalErrorMassage(Message.profileManagement.addProfileRequester);
          setopenProfileErrorModal(true);
        }
      } else if (roleTypeData === "Respondent") {
        let RespondentProfileStatus = "";
        CreatedRoleData?.map((name, index) => {
          if (
            name.roleType === "Requester" &&
            [
              "Pending",
              "pending",
              "PENDING",
              "Not Completed",
              "Not completed",
              "not completed",
              "NOT COMPLETED",
              "Rejected",
              "rejected",
              "REJECTED",
            ].includes(name.profileStatus)
          ) {
            return (RespondentProfileStatus = name.profileStatus);
          }
        });
        if (
          [
            "Pending",
            "pending",
            "PENDING",
            "Not Completed",
            "Not completed",
            "not completed",
            "NOT COMPLETED",
            "Rejected",
            "rejected",
            "REJECTED",
          ].includes(RespondentProfileStatus)
        ) {
          isValid = false;
          setRoleMessage("");
          setSelectedRoleType("");
          setRoleTypeData("");
          setRoleNameData("");
          setmodalErrorMassage(Message.profileManagement.addProfileRespondent);
          setopenProfileErrorModal(true);
        }
      }
    }
    return isValid;
  };
  const workFlowApiNewRequesterOrRespondent = (formAction) => {
    ApiCall(
      "POST",
      workFlowBaseURL + START_PROFILE_ENDPOINT + `?action=${formAction}`,
      {
        email: userProfileDataR?.userEmail,
        firstName: userProfileDataR?.firstName,
        lastName: userProfileDataR?.lastName,
        mobileNumber: userProfileDataR?.userMobile,
        profileRole: {
          roleId: roleIdData,
          roleName: roleNameData,
          roleType: roleTypeData,
        },
        userId: userProfileDataR?.userId,
        submitDate: new Date().getTime(),
      },
      {
        Accept: "application/json",
        "Content-Type": "application/json",
      }
    ).then((data) => {
      if (data.flag != -1) {
        if (data.flag == "500") {
          console.log("I am 500!");
        } else {
          console.log("I am 200!");
          sethasOpenOnSubmit(true);
        }
      } else {
        console.log("Something went wrong!");
      }
    });
  };
  const handleSubmit = (event) => {
    if (validate()) {
      if (roleTypeData === "Requester") {
        if (profileStatus) {
          history.push({
            pathname: `/CompanyInfo/${roleIdData}/${roleTypeData}/${roleNameData}/${profileStatus}`,
          });
        } else {
          if (isRespondentProfileAppooved) {
            // submit requester profile if respondent profile is already approved
            workFlowApiNewRequesterOrRespondent("submit");
          } else {
            //add profile for requester
            history.push({
              pathname: `/verifyMobile/${roleIdData}/${roleTypeData}/${roleNameData}/${"add-profile"}/${"company-info"}`,
            });
          }
        }
      } else if (roleTypeData === "Respondent") {
        if (profileStatus) {
          history.push({
            pathname: `/CompanyInfo/${roleIdData}/${roleTypeData}/${roleNameData}/${profileStatus}`,
          });
        } else {
          let RequesterProfileAppooved = false;
          CreatedRoleData?.map((name) => {
            if (
              name.roleType === "Requester" &&
              ["Approved", "approved", "APPROVED"].includes(name.profileStatus)
            ) {
              return (RequesterProfileAppooved = true);
            }
          });
          if (RequesterProfileAppooved) {
            workFlowApiNewRequesterOrRespondent("submit");
          } else {
            history.push({
              pathname: `/verifyMobile/${roleIdData}/${roleTypeData}/${roleNameData}/${"add-profile"}/${"company-info"}`,
            });
          }
        }
      } else if (roleTypeData === "Driver") {
        if (profileStatus) {
          history.push({
            pathname: `/DriverProfile/${roleIdData}/${roleTypeData}/${roleNameData}/${profileStatus}`,
          });
        } else {
          history.push({
            pathname: `/verifyMobile/${roleIdData}/${roleTypeData}/${roleNameData}/${"add-profile"}/${"id-info"}`,
          });
        }
      } else {
        console.log("Add Profile--> No Profile");
      }
    }
  };
  const handleClickOutside = (event) => {
    if (container.current && !container.current.contains(event.target)) {
      setDropDownRoleType(false);
      setDropDownRoleName(false);
    }
  };
  const toggleRoleTypeDropdown = () => {
    setDropDownRoleType(!dropDownRoleType);
  };
  const toggleRoleNameDropdown = () => {
    if (selectedRoleType?.length === 0) {
      setDropDownRoleName(false);
    } else {
      setDropDownRoleName(!dropDownRoleName);
    }
  };
  const handleCustomerSupport = () => {
    history.push("/ContactUs");
  };
  const roleTypeDropdownImage = dropDownRoleType ? (
    <img src={drawer} />
  ) : (
      <img src={downarrow} />
    );
  const roleNameDropdownImage = dropDownRoleName ? (
    <img src={drawer} />
  ) : (
      <img src={downarrow} />
    );
  return (
    <div>
      <div class="outer11">
        <MetaDecorator
          title={TitleDescription.addProfilePageTitle}
          description={TitleDescription.addProfilePageDescription}
        />
        <Header tilesFetched={() => { }} />
        <div class="midDiv" id="addbox1">
          <div class="upNav">
            <div class="ad01">
              <small class="" id="cccc">
                Add Profile{" "}
              </small>
            </div>
          </div>
          <hr class="hr1" />
          <div class="addProfilerow2">
            <div></div>
            <div class="ad02">
              <div class="ad03">
                <small class="p-1" id="" class="ad04">
                  Role Type{" "}
                </small>
              </div>
              <div class="addProfileRoleDropDiv">
                <div className="pass-wrapper" id="ad07">
                  <input
                    readOnly
                    class="form-control form-control-sm outline4"
                    placeholder="Select Role Type"
                    type="text"
                    id="ad06"
                    value={roleTypeData}
                  />
                  <i
                    id={
                      dropdownImagePointer
                        ? "input_imgAddProfile"
                        : "input_imgAddProfilePointer"
                    }
                    onClick={toggleRoleTypeDropdown}
                  >
                    {roleTypeDropdownImage}
                  </i>
                  {dropDownRoleType && (
                    <div class="ad08">
                      <div class="dropdowncard" ref={container}>
                        {RoleData?.map((name, index) => {
                          return (
                            <DropDownTable
                              onClick={() => changeRoleType(index)}
                            >
                              <small class="" id="tt2">
                                {name.role}{" "}
                              </small>
                            </DropDownTable>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
                <div className="addprofileerror">{errors.roletype}</div>
                {roleMessage != "" && (
                  <div class="addprofileRoleInfoMsgDiv">
                    <small class="addprofileRoleInfoMsg">
                      A{" "}
                      <small class="addprofileRoleInfoBold">
                        {roleTypeData}
                      </small>{" "}
                      {roleMessage}
                    </small>
                  </div>
                )}
              </div>
            </div>
            <div class="ad10">
              <div class="ad03">
                <small class="pt-1 pb-1" id="ad044">
                  Role Name{" "}
                </small>
              </div>
              <div class="addProfileRoleDropDiv">
                <div className="pass-wrapper" id="ad07">
                  <input
                    readOnly
                    class="form-control form-control-sm outline4"
                    placeholder="Select Role Name"
                    type="text"
                    id="ad06"
                    value={roleNameData}
                  />
                  <i id="input_imgAddProfile" onClick={toggleRoleNameDropdown}>
                    {roleNameDropdownImage}
                  </i>
                  {dropDownRoleName && (
                    <div class="ad08">
                      <div class="dropdowncard2" ref={container}>
                        {RoleData?.map((name, index) => {
                          if (name.role === selectedRoleType) {
                            return (
                              <>
                                {name.roleType?.map((nameofrole, i) => {
                                  return (
                                    <DropDownTable onClick={changeRoleName}>
                                      <small class="" id="tt2">
                                        {nameofrole.roleName}{" "}
                                      </small>
                                    </DropDownTable>
                                  );
                                })}
                              </>
                            );
                          }
                        })}
                      </div>
                    </div>
                  )}
                </div>
                <div className="addprofileerror">{errors.rolename}</div>
              </div>
            </div>
          </div>
          <div class="mobileundisply">
            <div class="please2">
              <small class="please">
                Please contact{" "}
                <small
                  class="addCustomerSupportText"
                  onClick={handleCustomerSupport}
                >
                  customer support
                </small>{" "}
                to add a new Role Name.
              </small>
            </div>
            <div class="butt1">
              <Button class="butt" onClick={handleSubmit}>
                {isRespondentProfileAppooved ? (
                  <small class="bt01">Submit</small>
                ) : (
                    <small class="bt01"> Continue</small>
                  )}
              </Button>
            </div>
          </div>
        </div>
        <div class="addfooter22">
          <Footer2 />
        </div>
      </div>
      <div class="addfooter11">
        <div class="please2">
          <small class="please">
            Please contact{" "}
            <small
              class="addCustomerSupportText"
              onClick={handleCustomerSupport}
            >
              customer support
            </small>{" "}
            to add a new Role name.
          </small>
        </div>
        <div class="butt1">
          <Button class="butt" onClick={handleSubmit}>
            <small class="bt01"> Continue</small>
          </Button>
        </div>
        <Footer />
      </div>
      {openProfileErrorModal ? (
        <AddProfileModal
          hasOpen={openProfileErrorModal}
          onCloseModal={onCloseProfileErrorModal}
        >
          <div>
            <div class="successtext1outercreatepreadvise">
              <small class="addprofilemodalsmall">{modalErrorMassage}</small>
            </div>
          </div>
        </AddProfileModal>
      ) : null}
      <SubmitModal
        hasOpen={hasOpenOnSubmit}
        onCloseModal={onCloseSubmitModal}
      />
    </div>
  );
};
export default AddProfile;
